import { useParams } from 'react-router-dom';


import AgModalWindow from '@/components/common/ModalWindow/AgModalWindow';
import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';
import Spinner from '@/components/common/Spinner/Spinner';
import ContractLineCustomerHeader from './ContractLineCustomerHeader/ContractLineCustomerHeader';

interface IBillingCadenceProps {
  onClose: () => void;
}

export default function BulkUpdateClCustomersModal({
  onClose
}: IBillingCadenceProps) {
  const { contractId }: { contractId: UUID } = useParams();
  const { contract, isContractLoading } = useGetContractDetails(contractId);

  return (
      <AgModalWindow
        title={'Update Ship/Invoice To Accounts'}
        isOpen={true}
        onClose={onClose}
        contentStyle={{ minWidth: '1000px', maxWidth: '1200px' }}
      >
        {isContractLoading &&
          <div className="d-flex justify-content-center align-items-center" style={{ height: 200 }}>
          <Spinner />
        </div>
        }
        {!isContractLoading && 
        <>
          <ContractLineCustomerHeader contractId={contractId} contract={contract} onClose={onClose}/>
        </>
        }
      </AgModalWindow>
  );
}